module.exports = __webpack_public_path__ + "img/report-icon-3.86ccd661.png";